import React from 'react';
import PropTypes from 'prop-types';
import LoadingIcon from 'mdi-react/LoadingIcon';

const LoaderOverlay = ({ loading }) => (
  <React.Fragment>
    {loading && <div className="loader"><LoadingIcon /></div>}
  </React.Fragment>
);

LoaderOverlay.propTypes = {
  loading: PropTypes.bool.isRequired,
};

export default LoaderOverlay;
